import { memo, useState } from 'react';
import cn from 'classnames';
import { Button, Element, Icon, IconButton, Title } from 'src/components';
import Card from 'src/components/card';
import Radio from 'src/components/form/radio';
import Message from 'src/components/message';
import SelectContent from './SelectContent';

export default memo(function ModalReport({ hide, contentId, reportFn }: any) {
    const [value, setValue] = useState(undefined);
    const [contents, setContent] = useState([]);
    const [other, setOther] = useState('');
    const [err, setErr] = useState('');
    const onChangeOption = (value: any) => {
        setValue(value);
        setErr('');
    };

    const handleSubmit = () => {
        let feedback: any = {
            type: value,
        };
        if (value === 'content') {
            if (!contents.length) {
                return setErr('Bạn chưa nhập nội dung');
            }
            feedback = {
                ...feedback,
                tags: contents,
            };
        } else if (value === 'other') {
            if (!other) {
                return setErr('Bạn chưa nhập nội dung');
            }
            feedback = {
                ...feedback,
                message: other,
            };
        }
        reportFn({
            object_id: contentId,
            feedback: JSON.stringify(feedback),
            object_type: 0,
        });
    };

    return (
        <Card>
            <Card.Header
                className={cn(
                    'relative',
                    'flex items-center',
                    'px-[25px]',
                    'h-[52px]',
                    'text-center',
                    'border border-solid border-[#e9ecef]',
                    'rounded-t-[12px]',
                    'bg-[#F8F9FA]',
                )}
            >
                <Title className="text-[20px] font-[800]">Báo tin xấu</Title>

                <IconButton
                    onClick={hide}
                    icon="new-x-close-light"
                    className={cn(
                        'absolute top-1/2 right-[8px]',
                        '-translate-y-1/2',
                        'p-[4px]',
                    )}
                    classNameIcon="text-[12px] text-[#131214]"
                />
            </Card.Header>
            <Card.Content className="px-[30px] py-[20px]">
                <Element className={'text-[16px] text-[#131214] font-semibold'}>
                    Bạn vui lòng cho biết bài viết gặp lỗi nội dung nào:
                </Element>
                <Radio
                    className="mt-[16px] ml-[-8px]"
                    value={value}
                    onChange={onChangeOption}
                >
                    <Element
                        className={cn(
                            'flex items-center',
                            'min-h-[36px]',
                            'pl-[8px]',
                            'rounded-full',
                            {
                                ['bg-[#2FA1B30D]']:
                                    value === 'original_removed',
                            },
                        )}
                    >
                        <Radio.Item value="original_removed">
                            Tin gốc đã gỡ
                        </Radio.Item>
                    </Element>
                    <Element
                        className={cn(
                            'flex items-center',
                            'min-h-[36px]',
                            'pl-[8px]',
                            'rounded-full',
                            {
                                ['bg-[#2FA1B30D]']:
                                    value === 'original_updated',
                            },
                        )}
                    >
                        <Radio.Item value="original_updated">
                            Tin gốc đã cập nhật
                        </Radio.Item>
                    </Element>
                    <Element
                        className={cn(
                            'flex items-center',
                            'rounded-[12px]',
                            'min-h-[36px]',
                            'p-[8px]',
                            {
                                ['bg-[#2FA1B30D]']: value === 'content',
                            },
                        )}
                    >
                        <Radio.Item value="content">
                            Nội dung không phù hợp
                            {value === 'content' && (
                                <SelectContent
                                    setContent={setContent}
                                    contents={contents}
                                />
                            )}
                        </Radio.Item>
                    </Element>
                    <Element
                        className={cn(
                            'flex items-center flex-wrap',
                            'rounded-[12px]',
                            'min-h-[36px]',
                            'p-[8px]',
                            {
                                ['bg-[#2FA1B30D]']: value === 'other',
                            },
                        )}
                    >
                        <Radio.Item value="other">Ý kiến khác ...</Radio.Item>
                        {value === 'other' && (
                            <textarea
                                name="other"
                                value={other}
                                onChange={(e) => {
                                    setOther(e.target.value);
                                    setErr('');
                                }}
                                className={cn(
                                    'w-full',
                                    'text-[14px] leading-[1.3] text-[#495057]',
                                    'p-[8px] mt-[8px]',
                                    'bg-white',
                                    'rounded-[16px]',
                                    'border border-solid border-[#DAF1F6]',
                                )}
                                rows={3}
                            />
                        )}
                    </Element>
                </Radio>
                {err && <Message>Bạn chưa nhập nội dung!</Message>}
            </Card.Content>
            <Card.Footer
                className={cn(
                    'flex-nowrap',
                    'px-[25px] pb-[20px] mt-0',
                    'h-auto',
                    'rounded-none',
                    'text-center',
                )}
            >
                <Button
                    className={cn(
                        'rounded-[8px]',
                        'w-1/2 h-auto',
                        'text-[16px] leading-[1] font-bold',
                        'py-[12px]',
                        'border border-solid border-[#E5E5E5]',
                        'text-[#131214]',
                    )}
                    onClick={hide}
                >
                    Đóng
                </Button>
                <Button
                    onClick={handleSubmit}
                    className={cn(
                        'rounded-[8px]',
                        'w-1/2 h-auto',
                        'text-[16px] leading-[1] font-bold',
                        'py-[12px]',
                    )}
                    color={'primary'}
                >
                    Gửi báo lỗi
                </Button>
            </Card.Footer>
        </Card>
    );
});
